import { Info, X } from "lucide-react";
import { useState } from "react";
import { useSite } from "@/context/SiteContext";

export function StoreClosedBanner() {
  const { storeOpen, settings } = useSite();
  const [dismissed, setDismissed] = useState(false);
  if (storeOpen || dismissed) return null;
  return (
    <div data-testid="store-closed-banner" className="bg-amber-100 text-amber-950 dark:bg-amber-950 dark:text-amber-100 border-b border-amber-200 dark:border-amber-900">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 text-sm">
        <Info className="h-4 w-4 shrink-0" />
        <p className="text-center">{settings?.closed_message || "Online orders are currently closed."}</p>
        <button
          data-testid="store-closed-dismiss-btn"
          onClick={() => setDismissed(true)}
          className="ml-2 p-1 rounded-full hover:bg-amber-200/60 dark:hover:bg-amber-900/60"
          aria-label="Dismiss"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
